import React from 'react';
import { exploreLinks } from '../../data/websites';
export function ExploreMore() {
  return <nav aria-label="Explore more" className="border-t border-gray-200 bg-white px-[clamp(1rem,4vw,6rem)] py-8" data-id="element-842" data-mp="30tgk3jgl24bc">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-10" data-id="element-843" data-mp="2ms45pch2mark">
        <p className="flex-shrink-0 text-sm font-bold uppercase tracking-[0.14em] text-brand-gray" data-id="element-844" data-mp="2rrqtugyftbf5">Explore more</p>
        <ul className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-845" data-mp="2d2b6zc211q4q">
          {exploreLinks.map(link => <li key={link.label} data-id="element-846" data-mp="2hv4bpzxhwygt">
              <a href={link.href} {...link.external ? {
            target: '_blank',
            rel: 'noopener noreferrer'
          } : {}} className="font-semibold text-brand-black underline-offset-4 transition-colors duration-150 ease-out hover:text-brand-red hover:underline focus:outline-none focus-visible:underline" data-id="element-847" data-mp="2hvdrkuottp8s">
                {link.label}
              </a>
            </li>)}
        </ul>
      </div>
    </nav>;
}